import firebase from '@/plugins/Firebase';

export const EVENTO_CONTATO_SUPORTE = 'support_contact_clicked';

export function registrarContatoSuporte (origem, estabelecimento) {
  firebase.logEvent(EVENTO_CONTATO_SUPORTE, {
    origem,
    establishment_id: (estabelecimento && estabelecimento.id) || null,
  }).catch(() => {});
}
